import { useFiltersView } from '../../../../lib/context/FiltersViewContext';
import Pagination from '../Pagination/Pagination';
import { PureSeparator } from '../../compound/Separator/Separator';
import AchievementsList from '../AchievementsList/AchievementsList';
import SkeletonAchievmentsList from '../AchievementsList/SkeletonAchievmentsList';
import styles from './FilteredCardsView.module.scss';

const MyAchievementsSection = () => {
  const filtersProps = useFiltersView();
  const { filters, updateFilters, totalPages, achievements, loading, isAchievements } = filtersProps ?? {};
  const updatePage = (page: number) => updateFilters(filters, page);

  if (loading === 'initial' && isAchievements) {
    return <SkeletonAchievmentsList />;
  }

  if (!achievements) {
    return null;
  }

  return (
    <>
      <PureSeparator className={styles.separator} />
      <AchievementsList achievements={achievements} />
      <Pagination
        currentPage={filters.page ?? 1}
        totalPages={totalPages}
        onChange={updatePage}
        className={styles.pagination}
      />
    </>
  );
};

export default MyAchievementsSection;
